import React, {useState, useCallback} from 'react';
import {connect} from 'react-redux';
import SubMacroEditor from 'components/effects/rack/SubMacroEditor.js';


const MacroDetails = ({macro}) => {
    const [name, setName] = useState(macro.name);
    const [isEditing, setIsEditing] = useState(false);

    const onChange = useCallback((e) => {
        setName(e.target.value);
        macro.name = e.target.value;
    }, [ setName, macro]);

    const onKeyUp = useCallback((e) => {
        if (e.key === 'Enter') {
            setIsEditing(false);
        }
    }, [setIsEditing]);

    return (
        <div className="macro-details">
          {isEditing ?
           <input type="text" value={name} onKeyUp={onKeyUp} onChange={onChange}/> :
           <div
             onClick={() => setIsEditing(true)}
             className="macro-name">
             {macro.name}
           </div>}
          {macro.subMacros.map(
              subMacro =>
                  <SubMacroEditor macro={macro} subMacro={subMacro}/>
          )}
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
      len: props.macro.subMacros.length
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MacroDetails);
